import axios from 'axios';

const DEFAULT_TIMEOUT = 30000;

class AdminClient {
  constructor(baseUrl) {
    this._httpClient = AdminClient.makeClient(baseUrl);
    this._httpClient.defaults.withCredentials = true;
  }

  static makeClient(baseUrl) {
    const client = axios.create({
      baseURL: baseUrl,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    });
    client.interceptors.request.use(function(config) {
      config.headers['x-newshub-trace'] =
        'ui-' +
        Math.random()
          .toString(36)
          .slice(2);

      return config;
    });
    return client;
  }

  getAdminUsers(token) {
    return this._httpClient
      .get('/admin/users', {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  getPlaces(token) {
    return this._httpClient
      .get('/admin/places', {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  getFolders(token) {
    return this._httpClient
      .get('/admin/folders', {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  createFolder(token, folder) {
    return this._httpClient
      .post('admin/folders', folder, {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  updateFolders(token, folderList) {
    return this._httpClient
      .put('/admin/folders', folderList, {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  isUserAdmin(token) {
    return this._httpClient
      .get(`/admin/users/is-admin`, {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  grantAdminRole(token, userObj) {
    return this._httpClient
      .post(`/admin/users`, userObj, {
        timeout: DEFAULT_TIMEOUT,
        headers: {
          Authorization: token,
        },
      })
      .then(response => response.data);
  }
  removeAdminRole(token, user_id) {
    return this._httpClient
      .delete(`/admin/users/${user_id}`, {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  getMirrorCategories(token) {
    return this._httpClient
      .get('/admin/mirror-categories', {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  createMirrorCategory(token, category) {
    return this._httpClient.post('/admin/mirror-categories', category, {
      timeout: DEFAULT_TIMEOUT,
      headers: { Authorization: token },
    });
  }

  updateMirrorCategory(token, category) {
    if (category.id) {
      return this._httpClient.put(
        `/admin/mirror-categories/${category.id}`,
        category,
        {
          timeout: DEFAULT_TIMEOUT,
          headers: { Authorization: token },
        },
      );
    }
  }

  deleteMirrorCategory(token, idCategory) {
    return this._httpClient.delete(`/admin/mirror-categories/${idCategory}`, {
      timeout: DEFAULT_TIMEOUT,
      headers: { Authorization: token },
    });
  }

  getMirrorFolders(token) {
    return this._httpClient
      .get('/admin/mirror-folders', {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  createMirrorFolder(token, mirror) {
    return this._httpClient
      .post('admin/mirror-folder', mirror, {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  updateMirrorFolder(token, mirror) {
    return this._httpClient
      .put('admin/mirror-folder', mirror, {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  removeMirror(token, mirror) {
    return this._httpClient
      .delete(`admin/mirror-folder/${mirror.folder_id}`, {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  getVariables(token) {
    return this._httpClient
      .get('/admin/variables', {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }

  updateVariables(token, variables) {
    return this._httpClient
      .put('admin/variable', variables, {
        timeout: DEFAULT_TIMEOUT,
        headers: { Authorization: token },
      })
      .then(response => response.data);
  }
}

export { AdminClient };
